import { AddBoxOutlined } from '@mui/icons-material';
import { Stack } from '@mui/material';
import Button from '@mui/material/Button';
import $ from 'jquery';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import utilsCategurys from '../../../../MyConns/_Utils/utilsCategurys';
import utilsRests from '../../../../MyConns/_Utils/utilsRests';
import CRTypeSelect from '../../../MySections/DTechComps/CRTypeSelect';
import MySpinner_Wait from '../../../MySections/DTechComps/MySpinner_Wait';
import RestStatusSelect from '../../../MySections/DTechComps/RestStatusSelect';
import EraseCheck from '../../../MySections/PopUps/EraseCheck';
import DTSearchBar from '../../compsForAllPages/DTSearchBar';
import Breadcrumb from './Breadcrumb';

const Restaurantcontent = (props) => {


    const history = useHistory();
    const [restaurentlisttable, setRestaurentlisttable] = useState([]);
    const [srchList, setSrchList] = useState([]);
    const [allCats, setAllCats] = useState([]);
    const [thePopUp, setThePopUp] = useState("");
    const [srchItm, setSrchItm] = useState("");
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        getAllRests();

    }, [])



    const getCatsNames = (catsLst) => {
        let catStr = "";

        catsLst.forEach(element => {
            allCats.map((cat, index) => {
                if (cat._id === element) {
                    (index > 1 && catStr != "") ? catStr += "," + cat.catHead : catStr = cat.catHead;
                }
            })
        });

        return catStr;
    }

    const getAllRests = async () => {

        setLoading(true);

        let RstList = await utilsRests.getRests();
        setRestaurentlisttable(RstList);

        let CatList = await utilsCategurys.getAllCategurys();
        setAllCats(CatList);

        setSrchItm(
            <DTSearchBar searchList={RstList} CatList={CatList}
                serachRslt={(lstBack) => setRestaurentlisttable(lstBack)} />
        )

        setLoading(false);
    }

    const addstars = (e) => {
        var elem = e.target,
            parentTask = elem.closest('.ms-rating-item');
        $(parentTask).prevAll().removeClass('rated');
        $(parentTask).addClass('rated');
        $(parentTask).nextAll().addClass('rated');
    }

    const removeBuis = (restId) => {
        setThePopUp(<EraseCheck title={'האם בטוח למחוק את העסק?'} sucecssFunc={() => removeBuisConfirmd(restId)} />)
    }
    const removeBuisConfirmd = async (restId) => {
        let mdlist = await utilsRests.deleteRest(restId);
        getAllRests();
    }

    const updateRestStatus = async (restId, stat) => {
        let mdlist = await utilsRests.updaterestStatus(restId, stat);

    }

    const updateCRType = async (restId, CRT) => {
        let mdlist = await utilsRests.updaterestCRType(restId, CRT);

    }


    const goTORest = (itmId) => {
        history.push("/Rest/" + itmId)
    }


    return (
        <>
            <div className="ms-content-wrapper">
                {loading ? <MySpinner_Wait /> :
                    <div className="row">
                        <div className="col-md-12">
                            <Breadcrumb />
                            {/* Active Orders Graph */}
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="ms-panel">
                                        <div className="ms-panel-header DTSearchBar" >
                                            <div className={"DTSearchBarWrap"}>
                                                <div className={"DTSearchBarIN"}><h6>כל העסקים</h6>
                                                    {srchItm}
                                                </div>
                                            </div>

                                            <div className={"buisTollBar"}>
                                                <Stack direction="row" spacing={2}>
                                                    <Link to={`/Rest`}>
                                                        <Button variant="contained" className={"theSBtn"}
                                                            startIcon={<AddBoxOutlined style={{ color: 'white' }} />}>
                                                            חדש
                                                        </Button>
                                                    </Link>
                                                </Stack>

                                            </div>
                                        </div>
                                        <div className="ms-panel-body">
                                            <div className="table-responsive">
                                                <table className="table table-hover thead-primary">
                                                    <thead>
                                                        <tr>
                                                            <th scope="row"></th>

                                                            <th scope="col">שם העסק</th>
                                                            <th scope="col">קטגוריות</th>
                                                            {/* <th scope="col">דירוג</th> */}
                                                            <th scope="col" className={"centerText"}>סוג קופה</th>
                                                            <th scope="col" className={"centerText"}>סטטוס</th>
                                                            <th scope="col" className={"centerText"}>משלוחים</th>
                                                            <th scope="col" className={"centerText"}>איסוף</th>
                                                            <th scope="col" className={"centerText"}>קישור</th>
                                                            <th scope="col" className={"centerText"}> ערוך / מחק</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {restaurentlisttable.map((item, i) => (
                                                            <tr key={item._id} itmid={item._id}  >
                                                                <td scope="row" className={"pointing"} onClick={() => goTORest(item._id)}>({parseInt(i) + 1}) </td>
                                                                <td scope="row" className={"pointing"} onClick={() => goTORest(item._id)}>{item.buissName} </td>
                                                                {/* <td>{item.buissKitchType}</td> */}

                                                                <td className={"pointing"} onClick={() => goTORest(item._id)}>
                                                                    {getCatsNames(item.buisCats)}</td>

                                                                <td className={"pointing"}>
                                                                    <div className={"CRTypeSelect"}>
                                                                        <CRTypeSelect restCRT={item.CRType ? item.CRType : "tablet"} onLeft={"onLeft"}
                                                                            CRTUpdate={(CRT) => updateCRType(item._id, CRT)} />
                                                                    </div>
                                                                </td>

                                                                <td className={"pointing"}>
                                                                    <div className={"RestStatusSelect"}>
                                                                        <RestStatusSelect restStatus={item.restStatus ? item.restStatus : "פעיל"}
                                                                            statusUpdate={(stat) => updateRestStatus(item._id, stat)} />
                                                                    </div>
                                                                </td>
                                                                <td scope="row" className={"pointing centerText"} >
                                                                    {item.Delivery.Doing ? <p className={"bold inGreen"}>V</p> : <p className={"bold inRed"}>X</p>}
                                                                </td>  
                                                                <td scope="row" className={"pointing centerText"} >
                                                                    {item.TakeAway.Doing ?<p className={"bold inGreen"}>V</p> : <p className={"bold inRed"}>X</p>}
                                                                </td>
                                                                <td className={"pointing"}>
                                                                    <div className={"RestStatusSelect"}>
                                                                        <p onClick={() => window.open("https://ashdodmenu.co.il/restaurants/" + item.pageUrlFix, "_blank")}>{item.pageUrlFix}</p>

                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className={"eraseEditBlock"}>
                                                                        <div className={"divAsIcon pointing"}><Link to={`/Rest/${item._id}`}><i className="fas fa-pencil-alt text-secondary" /></Link></div>
                                                                        <div className={"divAsIcon pointing"} onClick={() => removeBuis(item._id)}><i className="far fa-trash-alt ms-text-danger" /></div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
            {thePopUp}
        </>
    );


}

export default Restaurantcontent;

